// src/store/index.js
import { createStore } from 'vuex';

// Import your modules here
import locale from './modules/locale';

const store = createStore({
  modules: {
    locale,
  },
});

export default store;
